import { noop } from 'lodash';
import { browserHistory } from 'common/utils/browserHistory';
import callOrLog from 'src/common/utils/callOrLog';
import { NEW_CLIENT } from 'common/utils/EventTracker/utils/eventConstants';
import {
  ADD_INFORMATION_PATH,
  CONFIRM_PATH,
  NEW_SCREENING_PATH,
  SEARCH_PATH,
} from '../constants';
import STEP_DEFAULTS from './utils/defaults';

const screeningsStepperConfig = {
  steps: [
    {
      ...STEP_DEFAULTS.first,
      title: 'Search Records',
      onStepClick: () => {
        browserHistory.push(`/screenings/${SEARCH_PATH}`);
      },
      routes: [
        {
          route: `/screenings/${SEARCH_PATH}`,
        },
        {
          route: `/screenings/${CONFIRM_PATH}`,
        },
      ],
    },
    {
      ...STEP_DEFAULTS.second,
      title: 'Contact Information',
      onStepClick: noop,
      onStepComplete: ({
        contact = {},
        contactId = null,
        eventTracker = noop,
      }) => {
        const event = contactId ? NEW_CLIENT.updateFromScreening : NEW_CLIENT.createFromScreening;
        callOrLog(() => eventTracker(event, null, {
          contact,
        }));
        browserHistory.push(NEW_SCREENING_PATH);
      },
      routes: [
        {
          route: `/screenings/${ADD_INFORMATION_PATH}`,
        },
      ],
    },
    {
      ...STEP_DEFAULTS.third,
      title: 'Screening',
      onStepClick: () => {
        browserHistory.push(NEW_SCREENING_PATH);
      },
      isStepCompleted: () => false,
      routes: [
        {
          route: NEW_SCREENING_PATH,
        },
      ],
    },
  ],
};

export default screeningsStepperConfig;
